import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Enumify } from "enumify-ts";
import { CustomerAPIConsignmentStatusEnum } from "../api/Representation";
import React from "react";
import { Tag } from "antd";
export default class PartnerConsignmentStatusEnumify extends Enumify() {
    description;
    colour;
    static SCHEDULED = new PartnerConsignmentStatusEnumify("SCHEDULED", "#06e6f5");
    static TO_BE_RESCHEDULED = new PartnerConsignmentStatusEnumify("TO BE RESCHEDULED", "#f2930c");
    static IN_TRANSIT = new PartnerConsignmentStatusEnumify("IN TRANSIT", "#bab8f5");
    static ARRIVED = new PartnerConsignmentStatusEnumify("ARRIVED", "#7c5bf5");
    static ON_ROUTE = new PartnerConsignmentStatusEnumify("ON ROUTE", "#0802f5");
    static ON_ITS_WAY = new PartnerConsignmentStatusEnumify("ON ITS WAY", "#108ee9");
    static COMPLETED = new PartnerConsignmentStatusEnumify("COMPLETED", "#87d068");
    static _ = PartnerConsignmentStatusEnumify._closeEnum();
    static from(status) {
        return PartnerConsignmentStatusEnumify.valueOf(status);
    }
    renderTag() {
        return _jsx(Tag, { color: this.colour, children: this.description });
    }
    static renderTag(status) {
        const e = PartnerConsignmentStatusEnumify.valueOf(status);
        if (e) {
            return e.renderTag();
        }
        return _jsxs(Tag, { color: "red", children: ["?UNKNOWN: ", status, "?"] });
    }
    constructor(description, colour) {
        super();
        this.description = description;
        this.colour = colour;
    }
}
